<template>
  <div class="special_com">
    <div class="special_title" @click="toSpecialList">
      <span>专题</span>
      <i class="iconfont icon-more"></i>
    </div>
    <ul class="special_content">
      <li
        v-for="(item, index) in specialList"
        :key="index"
        class="special_list mar_top"
        @click="toSpecialDetail(item.id)"
      >
        <img src="//cdn.yxvzb.com/WEB/autoform/play.png" alt="" />
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'special',
  props: {
    specialList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    // 直接去专题详情
    toSpecialDetail(specialId) {
      this.$router.push({ name: 'special', params: { id: specialId } });
    },
    // 去专题列表页面
    toSpecialList() {
      this.$router.push({ name: 'specialList' });
    }
  }
};
</script>
<style lang="less" scoped>
@import '../../../public/style/g.less';
.special_com {
  padding: 0.31rem 0.45rem 0.51rem 0.51rem;
  width: 100%;
  font-size: 0.4rem;
  color: #161616;
  border-top: 0.27rem solid #f2f2f2;
  border-bottom: 0.27rem solid #f2f2f2;
  .special_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-weight: bold;
    }
    i {
      font-size: 0.6rem;
      color: #b9b9b9;
    }
  }
  .special_content {
    .mar_top {
      margin-top: 0.29rem;
    }
    .special_list {
      width: 95%;
      .textLimit();
      img {
        width: 0.4rem;
        height: 0.4rem;
      }
      span:nth-of-type(2) {
        margin-left: 0.23rem;
      }
    }
  }
}
</style>
